export default "ui-chart-areaspline{display:block}\n";